import * as tslib_1 from "tslib";
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
var MachineRobotVersionsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(MachineRobotVersionsModalComponent, _super);
    function MachineRobotVersionsModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MachineRobotVersionsModalComponent.prototype.onClose = function () {
        this._dialogRef.close();
    };
    return MachineRobotVersionsModalComponent;
}(UiModalComponent));
export { MachineRobotVersionsModalComponent };
